import { SupportRadioIcon, SupportTvIcon, TIcon } from '@acceso/design-system';

import { ChannelMediaTypeEnum } from '@/features/broadcasters/types';

export const CHANNEL_MEDIA_TYPE_TO_ICON: Record<ChannelMediaTypeEnum, TIcon> = {
  [ChannelMediaTypeEnum.TV]: SupportTvIcon,
  [ChannelMediaTypeEnum.RADIO]: SupportRadioIcon,
  [ChannelMediaTypeEnum.AUDIO_PODCAST]: () => <></>,
  [ChannelMediaTypeEnum.STREAMING]: () => <></>,
};
